import { DataObject } from "../DataObject";
import { Checker } from "@/lib/Checker";
import { Time } from "@/lib/Time";

export class Record extends DataObject {
  static type = {
    duration: "d",
    checkIn: "c"
  };
  constructor(path) {
    super({
      path: path,
      data: {
        type: Record.type.duration,
        creationTimestamp: new Date(),
        endTimestamp: new Date(),
        value: 0,
        UTCOffset: Time.date.getUTCOffSet(),
        note: "",
        userId: "",
        projectId: ""
      },
      validator: data => {
        const {
          type,
          creationTimestamp,
          endTimestamp,
          value,
          UTCOffset,
          note,
          userId,
          projectId
        } = data;
        Checker.checkTypes(type, ["string"], "type");
        Checker.checkTypes(creationTimestamp, [Date], "creationTimestamp");
        Checker.checkTypes(endTimestamp, [Date], "endTimestamp");
        Checker.checkTypes(value, ["number"], "value");
        Checker.checkTypes(UTCOffset, ["number"], "UTCOffset");
        Checker.checkTypes(note, ["string"], "note");
        Checker.checkTypes(userId, ["string"], "userId");
        Checker.checkTypes(projectId, ["string"], "projectId");
      }
    });
  }

  onSave(cb) {
    this._onSaveHandler = cb;
  }

  onRemove(cb) {
    this._onRemoveHandler = cb;
  }

  remove() {
    if (this._onRemoveHandler != undefined) this._onRemoveHandler();
    return super.remove();
  }
  save() {
    if (this._onSaveHandler != undefined) this._onSaveHandler();
    return super.save();
  }

  isCheckIn() {
    return this.data.type === Record.type.checkIn;
  }

  isDuration() {
    return this.data.type == Record.type.duration;
  }

  hasNote() {
    return (
      this.data.note !== undefined &&
      this.data.note !== null &&
      this.data.note.length > 0
    );
  }

  get projectId() {
    return this.data.projectId;
  }

  get value() {
    return this.data.value;
  }
}
